import styled from 'styled-components';
export const BarsBase = styled.div.attrs({
    className: 'bars',
}) `
  display: inline-flex;
`;
export const Bar = styled.div `
  height: ${(props) => (props.$size === 'small' ? '18px' : '24px')};
  width: ${(props) => (props.$size === 'small' ? '4px' : '6px')};
  border-radius: 4px;
  background: ${(props) => {
    if (!props.$filled) {
        return 'var(--color-graph-00)';
    }
    return props.$variant === 'sustainability'
        ? 'var(--color-green-50)'
        : 'var(--color-graph-06)';
}};

  & + & {
    margin-left: ${(props) => (props.$size === 'small' ? '4px' : '6px')};
  }
`;
